export default "__VITE_ASSET__CqspG3Ps__"